import { render } from "./QuillEditor.vue?vue&type=template&id=1f36a210&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"

import "./QuillEditor.vue?vue&type=style&index=0&id=1f36a210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f36a210"]])

export default __exports__